import { Box, Container, Typography, Paper, Button, Stack } from "@mui/material";
import { useState } from "react";
import RulesEnglish from "./RulesEnglish";
import RulesSpanish from "./RulesSpanish";
import RulesPortugues from "./RulesPortugues";

function RulesSection() {
  const [language, setLanguage] = useState("en");

  const titles = {
    en: "Tournament Rules",
    es: "Reglas del Torneo",
    pt: "Regras do Torneio",
  };

  return (
    <Box component="section" sx={{ py: { xs: 6, md: 9 } }}>
      <Container maxWidth="md">
        <Typography
          sx={{
            textAlign: "center",
            fontWeight: 800,
            fontSize: { xs: "2rem", md: "2.6rem" },
            color: "primary.main",
            mb: 4,
          }}
        >
          {titles[language]}
        </Typography>

        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={1.5}
          justifyContent="center"
          alignItems="center"
          sx={{ mb: 4 }}
        >
          <Button
            variant={language === "en" ? "contained" : "outlined"}
            onClick={() => setLanguage("en")}
            startIcon={
              <img
                src="https://flagcdn.com/w40/us.png"
                alt="English"
                style={{ width: 22, borderRadius: 2 }}
              />
            }
            sx={{
              minWidth: { xs: "100%", sm: 170 },
              height: 46,
              borderRadius: "14px",
              fontWeight: 700,
              px: 3,
            }}
          >
            English
          </Button>

          <Button
            variant={language === "es" ? "contained" : "outlined"}
            onClick={() => setLanguage("es")}
            startIcon={
              <img
                src="https://flagcdn.com/w40/es.png"
                alt="Español"
                style={{ width: 22, borderRadius: 2 }}
              />
            }
            sx={{
              minWidth: { xs: "100%", sm: 170 },
              height: 46,
              borderRadius: "14px",
              fontWeight: 700,
              px: 3,
            }}
          >
            Español
          </Button>

          <Button
            variant={language === "pt" ? "contained" : "outlined"}
            onClick={() => setLanguage("pt")}
            startIcon={
              <img
                src="https://flagcdn.com/w40/pt.png"
                alt="Português"
                style={{ width: 22, borderRadius: 2 }}
              />
            }
            sx={{
              minWidth: { xs: "100%", sm: 170 },
              height: 46,
              borderRadius: "14px",
              fontWeight: 700,
              px: 3,
            }}
          >
            Português
          </Button>
        </Stack>

        <Paper
          elevation={0}
          sx={{
            borderRadius: "22px",
            border: "1px solid #e5e7eb",
            p: { xs: 2.2, md: 3 },
            backgroundColor: "#fff",
          }}
        >
          {language === "en" && <RulesEnglish />}
          {language === "es" && <RulesSpanish />}
          {language === "pt" && <RulesPortugues />}
        </Paper>
      </Container>
    </Box>
  );
}

export default RulesSection;